<template>
  <div v-loading="loading" ref="intersectionGroups" class="group-wrapper">
    <button
      v-for="group in messageGroups"
      :key="group.id"
      @click="showChart(group.id)"
      class="group"
      :class="{ active: group.id === messageGroupId }"
    >
      <div class="name">{{ group.name }}</div>
      <div class="time">
        {{
          group.lastMessage.id !== 0
            ? new Date(group.lastMessage.createdDate).toLocaleDateString()
            : "нет сообщений..."
        }}
        {{
          group.lastMessage.id !== 0
            ? new Date(group.lastMessage.createdDate).toLocaleTimeString()
            : ""
        }}
      </div>
      <div class="last-message" v-if="group.lastMessage.id">
        {{ group.lastMessage.content }}
      </div>
    </button>
    <div ref="observerGroupsTrigger">&nbsp;</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    messageGroupId: {
      type: Number,
      default: null
    },
    nameFilter: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      observer: null,
      loading: false,
      messageGroups: [],
      page: 1
    };
  },
  computed: {},
  methods: {
    async loadData() {
      this.page = 1;
      this.loading = true;
      try {
        this.messageGroups = await this.$store.dispatch("fetchMessageGroups", {
          nameFilter: this.nameFilter,
          page: this.page
        });
        if (this.messageGroups.length === 10) {
          this.createObserver();
        }
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      } finally {
        this.loading = false;
      }
    },
    async loadMoreData() {
      this.page++;
      try {
        const result = await this.$store.dispatch("fetchMessageGroups", {
          nameFilter: this.nameFilter,
          page: this.page
        });
        this.messageGroups = [...this.messageGroups, ...result];
        if (result.length % 10 !== 0 && result.length > 0 && this.observer) {
          this.unobserveIntersecting();
        }
      } catch (error) {
        this.error = this.$ErrorsMod(e);
      }
    },
    showChart(messageGroupId) {
      this.$emit("showChart", messageGroupId);
    },
    createObserver() {
      const callback = e => {
        if (e[0].isIntersecting) {
          const beforeH = this.$refs.intersectionGroups.scrollTop;
          this.loadMoreData();
          this.$refs.intersectionGroups.scrollTop = beforeH;
        }
      };
      const options = {
        root: this.$refs.intersectionGroups,
        rootMargin: "0px",
        threshold: 0
      };
      this.observer = new IntersectionObserver(callback, options);
      this.observer.observe(this.$refs.observerGroupsTrigger);
    },
    unobserveIntersecting() {
      if (this.$refs.observerGroupsTrigger) {
        this.observer.unobserve(this.$refs.observerGroupsTrigger);
      }
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    nameFilter() {
      this.loadData();
    }
  }
};
</script>
<style scoped>
.group-wrapper {
  overflow: hidden auto;
  height: 100%;
  padding: 1em 0;
}
.group {
  padding: 0.5em;
  display: block;
  box-sizing: border-box;
  background: none;
  width: 100%;
  border: none;
  text-align: start;
  border-bottom: 1px solid #e6e6e6;
  cursor: pointer;
  overflow: hidden;
}
.group:hover {
  background: #40a0ff42;
}
.group.active {
  background: #40a0ff25;
}
.name {
  font-weight: bold;
  margin-bottom: 0.5em;
}
.time {
  font-weight: 100;
  font-size: 0.75em;
  color: #909399;
}
.last-message {
  margin-top: 0.5em;
  font-weight: 100;
  color: #909399;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
